import { render, staticRenderFns } from "./CardDiscountBadges.vue?vue&type=template&id=15024efa&scoped=true&"
import script from "./CardDiscountBadges.vue?vue&type=script&lang=js&"
export * from "./CardDiscountBadges.vue?vue&type=script&lang=js&"
import style0 from "./CardDiscountBadges.vue?vue&type=style&index=0&id=15024efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15024efa",
  null
  
)

export default component.exports